import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface selectCcif {
  selectedCcif: any[]; 
}

const initialState: selectCcif = {
  selectedCcif: [],
};
const selectCcifSlice = createSlice({
  name: 'selectCcif',
  initialState,
  reducers: {
    setselectCcif: (state, action: PayloadAction<any[]>) => {
      state.selectedCcif = action.payload;
    },
  },
});

export const { setselectCcif } = selectCcifSlice.actions
export default selectCcifSlice.reducer;